<template>
  <div v-if="show" class="col-auto col-xl">
    <div class="row step-indicator justify-content-between">
      <template v-for="(step, index) in steps">
        <router-link
          class="step-indicator-item col-auto text-center"
          v-if="enableLink(index)"
          :to="{ name: step.path }"
          :key="index"
        >
          <div
            :class="{
              'step-item d-flex flex-column align-items-center': true,
              active: index + 1 === selectedStep(),
              done: index + 1 < selectedStep(),
            }"
          >
            <span class="circle rounded-circle">{{ index + 1 }}</span>
            <span>{{ step.name }}</span>
          </div>
        </router-link>

        <div v-else class="step-indicator-item col-auto text-center" :key="index">
          <div
            :class="{
              'step-item d-flex flex-column align-items-center': true,
              active: index + 1 === selectedStep(),
              done: index + 1 < selectedStep(),
            }"
          >
            <span class="circle rounded-circle">{{ index + 1 }}</span>
            <span>{{ step.name }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StepIndicator',
  data() {
    return {
      selectedStep: () => this.$store.getters.selectedStep,
    }
  },
  computed: {
    steps() {
      const {
        flow_pv,
        flow_checkout,
        flow_pre_installation,
        flow_installation,
        flow_post_installation,
      } = this.$store.getters.content
      const contentProposal = {
        name: flow_pv,
        path: 'ContentProposal',
        allLinkedSteps: ['ContentProposal', 'card-detail'],
      }
      const orderSummary = {
        name: flow_checkout,
        path: 'OrderSummary',
        allLinkedSteps: ['OrderSummary'],
      }
      const preInstallation = {
        name: flow_pre_installation,
        path: 'OrderSummary',
        allLinkedSteps: ['OrderSummary'],
      }
      const installation = {
        name: flow_installation,
        path: 'OrderSummary',
        allLinkedSteps: ['OrderSummary'],
      }
      const postInstallation = {
        name: flow_post_installation,
        path: 'OrderSummary',
        allLinkedSteps: ['OrderSummary'],
      }

      const items = this.pushStepperItems(
        contentProposal,
        orderSummary,
        preInstallation,
        installation,
        postInstallation
      )
      return items
    },
    show() {
      const path = this.$route.path
      // array with pages that don't show the stepIndicator
      const hiddenPaths = ['payment-confirmation']
      const includes = (substrpath) => path.indexOf(substrpath) !== -1
      // check if one of the hiddenPaths are included in route.path
      if (hiddenPaths.some(includes) || this.trsMode) {
        return false
      }
      return true
    },
    quoteCount() {
      if (this.$store.getters.quotes) {
        return this.$store.getters.quotes.length
      } else return 0
    },
  },
  methods: {
    updateStep() {
      const routeName = this.$route.name

      // select active step, the step that
      const stepNr =
        this.steps.findIndex((element) => element.allLinkedSteps.indexOf(routeName) > -1) + 1

      this.$store.commit('increment', stepNr)
    },
    pushStepperItems(
      contentProposal,
      orderSummary,
      preInstallation,
      installation,
      postInstallation
    ) {
      const items = []
      items.push(contentProposal, orderSummary, preInstallation, installation, postInstallation)
      return items
    },
    enableLink(index) {
      if (this.$store.getters.iquote.orderPlaced) return false
      else
        return (
          index + 1 < this.selectedStep() ||
          (this.quoteCount === 1 && index + 1 !== this.selectedStep())
        )
    },
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.updateStep()
      }
    },
  },
  mounted() {
    this.updateStep()
  },
}
</script>

<style scoped lang="scss">
$white: #fff;
$gray-700: #5c6670;
$circle-size: 24px;

.step-indicator-item {
  color: $gray-700;
  font-weight: 500;
  font-size: calc((13 / 16) * 1rem);

  &:hover {
    text-decoration: none;
  }

  > .step-item {
    opacity: 0.75;

    > .circle {
      opacity: 0.3;
      font-size: calc((12 / 16) * 1rem);
      width: $circle-size;
      height: $circle-size;
      line-height: $circle-size;
      margin-bottom: 1.15rem;
      color: $white;
      background-color: $gray-700;
    }

    &.active,
    &.done {
      font-weight: 700;

      &,
      > .circle {
        opacity: 1;
      }
    }

    &.done {
      > .circle {
        color: inherit;

        &:after {
          content: '';
          display: block;
          width: 6px;
          height: 10px;
          border-right: 2px solid $white;
          border-bottom: 2px solid $white;
          margin: -19px auto 0;
          transform: rotate(45deg);
        }
      }
    }
  }
}
</style>
